/**
 * Are You Drunk? – animation class name pools.
 * Pick one at random for image; subset for letters; one per option for answer options.
 */

export const DRUNK_IMAGE_ANIMATIONS = [
  'drunk-img--zoom',
  'drunk-img--rotate',
  'drunk-img--flicker',
  'drunk-img--wobble',
  'drunk-img--pulse',
  'drunk-img--sway',
  'drunk-img--blur',
  'drunk-img--opacity',
] as const;

export const DRUNK_LETTER_ANIMATIONS = [
  'drunk-letter--rotate',
  'drunk-letter--rotate-alt',
  'drunk-letter--jump',
  'drunk-letter--jump-alt',
  'drunk-letter--tilt',
  'drunk-letter--flip',
  'drunk-letter--zoom',
] as const;

export type DrunkLetterAnimation = (typeof DRUNK_LETTER_ANIMATIONS)[number];

export const DRUNK_OPTION_ANIMATIONS = [
  'drunk-option--shake',
  'drunk-option--shake-alt',
  'drunk-option--rotate',
  'drunk-option--rotate-alt',
  'drunk-option--wobble',
  'drunk-option--jitter',
] as const;

export function pickRandomImageAnimation(): (typeof DRUNK_IMAGE_ANIMATIONS)[number] {
  return DRUNK_IMAGE_ANIMATIONS[Math.floor(Math.random() * DRUNK_IMAGE_ANIMATIONS.length)];
}

/** Deterministic image animation from a string seed (e.g. question text or questionId). */
export function pickImageAnimationForSeed(seed: string): (typeof DRUNK_IMAGE_ANIMATIONS)[number] {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = (h << 5) - h + seed.charCodeAt(i);
    h |= 0;
  }
  return DRUNK_IMAGE_ANIMATIONS[Math.abs(h) % DRUNK_IMAGE_ANIMATIONS.length];
}

export function pickRandomLetterAnimation(): (typeof DRUNK_LETTER_ANIMATIONS)[number] {
  return DRUNK_LETTER_ANIMATIONS[Math.floor(Math.random() * DRUNK_LETTER_ANIMATIONS.length)];
}

export function pickRandomOptionAnimation(): (typeof DRUNK_OPTION_ANIMATIONS)[number] {
  return DRUNK_OPTION_ANIMATIONS[Math.floor(Math.random() * DRUNK_OPTION_ANIMATIONS.length)];
}

/** Deterministic option animation per index (for stable per-question option wobbles). */
export function pickOptionAnimationForIndex(seed: string | undefined, index: number): (typeof DRUNK_OPTION_ANIMATIONS)[number] {
  const s = `${seed ?? ''}-${index}`;
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return DRUNK_OPTION_ANIMATIONS[Math.abs(h) % DRUNK_OPTION_ANIMATIONS.length];
}

/** Deterministic delay in seconds (0–0.8) for option animation. */
export function pickOptionDelayForIndex(seed: string | undefined, index: number): number {
  const s = `${seed ?? ''}-d-${index}`;
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return (Math.abs(h) % 9) / 10; // 0, 0.1, ... 0.8
}
